import React from 'react';
import nl2br from 'react-nl2br';

let parseCounter = 0;

function parse(children) {
  let parsed = children;

  if(typeof children === 'string') {
    parsed = nl2br(children);
  }
  else if(React.isValidElement(children)) {
    parsed = React.cloneElement(
      children,
      { key: `parse${++parseCounter}` },
      parse(children.props.children)
    );
  }
  else if(children instanceof Array) {
    parsed = children.map(parse);
  }

  return parsed;
}

const Nl2br = ({ children, ...props }) => <span {...props}>{parse(children)}</span>;

export default Nl2br;
